import { Moment } from 'moment';
/** EDD 开通时数据不充足 */
enum EddSteps {
    FIRST = 1,
    SECOND,
    THIRD,
    FOURTH,
    FINAL,
}

/** EDD 开通时数据充足 */
enum EddShortSteps {
  FIRST = 1,
  FINAL,
}

const EDD_ABSOLUTE_BASE_PATH = '/edd/application';
const PROCESSING_TIME_PATH = `${EDD_ABSOLUTE_BASE_PATH}/processing-time`;
const WORKING_DAYS_PATH = `${EDD_ABSOLUTE_BASE_PATH}/working-days`;
const NON_SHIPPING_DAYS_PATH = `${EDD_ABSOLUTE_BASE_PATH}/nonshipping-days`;
const SHIPPING_METHOD_PATH = `${EDD_ABSOLUTE_BASE_PATH}/shipping-method`;
const LIVE_DATE_PATH = `${EDD_ABSOLUTE_BASE_PATH}/live-date`;
const SUBMITTED_PATH = `${EDD_ABSOLUTE_BASE_PATH}/submitted`;

const PROCESSING_TIME_FORM_NAME = 'processingTime';
const WORKING_DAYS_FORM_NAME = 'workingDays';
const NON_SHIPPING_DAYS_FORM_NAME = 'daysOff';
const CARRIER_FORM_NAME = 'carrier';
const SERVICE_FORM_NAME = 'service';
const LIVE_DATE_FORM_NAME = 'liveDateTimeStamp';

type StepToPath = Record<number, {back: string, forward: string}>;

/** 完整流程 */
const stepToPathMap: StepToPath = {
  [EddSteps.FIRST]: { back: '', forward: WORKING_DAYS_PATH },
  [EddSteps.SECOND]: { back: PROCESSING_TIME_PATH, forward: NON_SHIPPING_DAYS_PATH },
  [EddSteps.THIRD]: { back: WORKING_DAYS_PATH, forward: SHIPPING_METHOD_PATH },
  [EddSteps.FOURTH]: { back: NON_SHIPPING_DAYS_PATH, forward: LIVE_DATE_PATH },
  [EddSteps.FINAL]: { back: SHIPPING_METHOD_PATH, forward: '' },
};

/** 短流程 */
const stepToShortPathMap: StepToPath = {
  [EddShortSteps.FIRST]: { back: '', forward: LIVE_DATE_PATH },
  [EddShortSteps.FINAL]: { back: NON_SHIPPING_DAYS_PATH, forward: '' },
};

/** 完整流程表单类型 */
type EddFormType = {
  processingTime?: string;
  carrier?: string;
  service?: string;
  daysOff?: Array<number[]>;
  liveDateTimeStamp: Moment;
  workingDays?: number[];
}

export {
  EddSteps,
  EddShortSteps,
  stepToPathMap,
  stepToShortPathMap,
  PROCESSING_TIME_FORM_NAME,
  WORKING_DAYS_FORM_NAME,
  NON_SHIPPING_DAYS_FORM_NAME,
  CARRIER_FORM_NAME,
  SERVICE_FORM_NAME,
  LIVE_DATE_FORM_NAME,
  PROCESSING_TIME_PATH,
  WORKING_DAYS_PATH,
  NON_SHIPPING_DAYS_PATH,
  SHIPPING_METHOD_PATH,
  LIVE_DATE_PATH,
  SUBMITTED_PATH,
};

export type { EddFormType };
